import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import MediaTable from "../MediaTable";
import PagePosts from "../PagePosts";
import ScheduledPagePosts from "../ScheduledPagePosts";
import CommentsViewer from "../CommentsViewer";
import DiscoveryPrompt from "../components/discovery/DiscoveryPrompt";
import { useDiscovery } from "../components/discovery/DiscoveryContext";

export default function DashboardHomePage({ token, pageId, selectedPageData }) {
  const { setWizardOpen } = useDiscovery();
  const platform = selectedPageData?.hasInstagram ? "instagram" : "facebook";

  return (
    <Box className="flex flex-col gap-4 pb-8">
      <DiscoveryPrompt onStart={() => setWizardOpen(true)} />
      <Paper className="card-modern p-6">
        <Typography variant="h6" className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
          Recent Posts
        </Typography>
        <PagePosts token={token} pageId={pageId} platform={platform} />
      </Paper>

      <Paper className="card-modern p-6">
        <Typography variant="h6" className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
          All posts
        </Typography>
        <MediaTable token={token} pageId={pageId} />
      </Paper>

      <Paper className="card-modern p-6">
        <Typography variant="h6" className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
          Scheduled Posts
        </Typography>
        <ScheduledPagePosts token={token} pageId={pageId} />
      </Paper>

      <Paper className="card-modern p-6">
        <Typography variant="h6" className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
          Comments
        </Typography>
        <CommentsViewer token={token} pageId={pageId} />
      </Paper>
    </Box>
  );
}
